import type { CryptoCashierConfig } from '../../hooks/payment/resolveCryptoCashierConfig';
import {
  type PaymentGateway,
  type PaymentTransactionType,
  PAYMENT_GATEWAY,
  PAYMENT_TRANSACTION_TYPE,
} from '../../types/enums';
import KapopayDepositForm from '../forms/kapopay/KapopayDepositForm';
import KapopayWithdrawForm from '../forms/kapopay/KapopayWithdrawForm';
import Pay2LocalDepositForm from '../forms/pay2local/Pay2LocalDepositForm';
import Pay2LocalWithdrawForm from '../forms/pay2local/Pay2LocalWithdrawForm';
import LigdiCashDepositForm from '../forms/ligdicash/LigdiCashDepositForm';
import LigdiCashWithdrawForm from '../forms/ligdicash/LigdiCashWithdrawForm';
import { Alert } from '@mui/material';
import useLocalization from '../../hooks/useLocalization';
import { CRYPTO_PROVIDER_FORMS } from '../forms/crypto/cryptoProviderForms';

type PaymentFormRendererProps = {
  paymentGateway: PaymentGateway;
  transactionType: PaymentTransactionType;
  paymentProvider: string | null;
  cryptoCashier: CryptoCashierConfig;
};

const PaymentFormRenderer = ({
  paymentGateway,
  transactionType,
  paymentProvider,
  cryptoCashier,
}: PaymentFormRendererProps) => {
  const { t } = useLocalization();
  const CryptoForms = CRYPTO_PROVIDER_FORMS[cryptoCashier.provider];

  const formMap = {
    [PAYMENT_GATEWAY.KAPOPAY]: {
      [PAYMENT_TRANSACTION_TYPE.DEPOSIT]: <KapopayDepositForm />,
      [PAYMENT_TRANSACTION_TYPE.WITHDRAW]: <KapopayWithdrawForm />,
    },
    [PAYMENT_GATEWAY.PAY_2_LOCAL]: {
      [PAYMENT_TRANSACTION_TYPE.DEPOSIT]: <Pay2LocalDepositForm paymentProvider={paymentProvider} />,
      [PAYMENT_TRANSACTION_TYPE.WITHDRAW]: <Pay2LocalWithdrawForm paymentProvider={paymentProvider} />,
    },
    [PAYMENT_GATEWAY.LIGDICASH]: {
      [PAYMENT_TRANSACTION_TYPE.DEPOSIT]: <LigdiCashDepositForm paymentProvider={paymentProvider} />,
      [PAYMENT_TRANSACTION_TYPE.WITHDRAW]: <LigdiCashWithdrawForm paymentProvider={paymentProvider} />,
    },
    [PAYMENT_GATEWAY.CRYPTO]: {
      [PAYMENT_TRANSACTION_TYPE.DEPOSIT]: cryptoCashier.depositEnabled ? (
        <CryptoForms.Deposit paymentProvider={paymentProvider} />
      ) : (
        <Alert severity='info'>{t('zeroXUnavailable')}</Alert>
      ),
      [PAYMENT_TRANSACTION_TYPE.WITHDRAW]: cryptoCashier.withdrawalEnabled && (
        <CryptoForms.Withdraw paymentProvider={paymentProvider} />
      ),
    },
  };

  return formMap[paymentGateway][transactionType];
};

export default PaymentFormRenderer;
